import * as React from "react";

export type FilterKey = "line" | "id";
export interface IFilter {
  key: FilterKey;
  value: string;
}

interface IProps {
  onChange: (value: IFilter[]) => any;
}

interface IState {
  value: string;
}

export class FilterInput extends React.Component<IProps, IState> {
  public state = {
    value: "",
  };

  public render() {
    const { value } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <input
          value={value}
          placeholder="Filter"
          onChange={this.onChange}
          className="filter-input"
        />
      </form>
    );
  }

  private onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({ value });
  };

  private onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { value } = this.state;

    const tokens = value.split(" ");

    const filters: IFilter[] = tokens.map(token => {
      // Strip whitespace
      token = token.replace(/^\W+/, "").replace(/\W+$/, "");

      if (token.startsWith("line:")) {
        const lineID = token.replace(/^line:\W*/, "");

        return {
          key: "line",
          value: lineID,
        } as IFilter;
      } else {
        return {
          key: "id",
          value: token,
        } as IFilter;
      }
    });

    this.props.onChange(filters);
  };
}



// WEBPACK FOOTER //
// ./src/components/FilterInput.tsx